/** `React.lazy` that survives a dropped chunk download. */

import { lazy, type ComponentType } from 'react'

const RELOAD_KEY = 'chunk-reload-at'

const wait = (ms: number) => new Promise((r) => setTimeout(r, ms))

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyRetry<T extends ComponentType<any>>(load: () => Promise<{ default: T }>) {
  return lazy(async () => {
    for (let attempt = 0; ; attempt++) {
      try {
        return await load()
      } catch (e) {
        if (attempt < 2) {
          await wait(800 * (attempt + 1))
          continue
        }
        // A fresh page load fetches the chunk anew; at most once every 30 seconds.
        let last = 0
        try {
          last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0)
          sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
        } catch {
          throw e
        }
        if (Date.now() - last > 30_000) {
          window.location.reload()
          return new Promise<never>(() => undefined)
        }
        throw e
      }
    }
  })
}
